import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';

const LoadingIndicator = () => {
    return (
        <>
            Loading Mappings <FontAwesomeIcon icon={faRedoAlt} spin />
        </>
    );
};

export default LoadingIndicator;
